// extracted by mini-css-extract-plugin
module.exports = {"root":"LogoBar_root__07am8","content":"LogoBar_content__YexkL","copy":"LogoBar_copy__IoAUH","logos":"LogoBar_logos__tTfHU"};